// Contemplative band — full-width parchment section featuring the watercolor
// of Saint Francis in prayer alongside his Peace Prayer. Positioned between
// the Hero (Zurbarán background) and the About section so the two artworks
// never clash, and the eye flows from the dark cocoa hero into this airy,
// reverent passage before reaching the parish narrative.

export default function FrancisPrayer() {
  return (
    <section
      id="prayer"
      data-testid="francis-prayer"
      className="relative bg-parchment-100 overflow-hidden"
    >
      {/* Subtle parchment grain */}
      <div className="absolute inset-0 grain pointer-events-none opacity-40" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Watercolor portrait */}
          <div className="lg:col-span-6">
            <figure className="relative mx-auto max-w-[520px]">
              {/* Soft warm halo behind the image */}
              <div
                aria-hidden
                className="absolute -inset-6 bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.18),transparent_70%)] pointer-events-none"
              />
              <div className="relative border border-parchment-400 bg-parchment-50 p-3 shadow-md">
                <div className="relative aspect-square overflow-hidden">
                  <img
                    src="/saints/st-francis-prayer.jpg"
                    alt="Saint Francis of Assisi in prayer — watercolor"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
              <figcaption className="mt-4 text-center text-[10px] uppercase tracking-[0.28em] text-sage-dark font-sans">
                ✦ Saint Francis at Prayer ✦
              </figcaption>
            </figure>
          </div>

          {/* Peace Prayer */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-sage" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-sage-dark font-sans font-medium">
                The Peace Prayer
              </span>
            </div>
            <h2 className="font-serif italic text-cocoa-900 text-2xl md:text-3xl leading-snug">
              “Lord, make me an instrument of Your peace.”
            </h2>
            <blockquote className="mt-7 font-serif text-cocoa-800 leading-relaxed text-lg space-y-4 max-w-xl">
              <p>
                Where there is hatred, let me sow love;
                <br />
                where there is injury, pardon;
                <br />
                where there is doubt, faith;
                <br />
                where there is despair, hope.
              </p>
              <p>
                Where there is darkness, light;
                <br />
                and where there is sadness, joy.
              </p>
            </blockquote>
            <div className="mt-8 text-[11px] uppercase tracking-[0.28em] text-terracotta font-sans">
              — Attributed to St. Francis of Assisi
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gold rule */}
      <div className="relative h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />
    </section>
  );
}
